module.exports = __webpack_public_path__ + "static/1-6fc31e7037f60358a4ef7082b6f4a4ac.png";